import { render, staticRenderFns } from "./ContactRight.vue?vue&type=template&id=12e7550b&scoped=true"
import script from "./ContactRight.vue?vue&type=script&lang=js"
export * from "./ContactRight.vue?vue&type=script&lang=js"
import style0 from "./ContactRight.vue?vue&type=style&index=0&id=12e7550b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e7550b",
  null
  
)

export default component.exports